/* eslint-disable no-unused-vars */
// This file exports globals (ON_CHANGE_DEBOUNCE_TIMER, PUB_SUB_EVENTS) used by other theme files loaded via script tags

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
